import { render, staticRenderFns } from "./QuemSomos.vue?vue&type=template&id=d7ff6b6e&scoped=true&"
import script from "./QuemSomos.vue?vue&type=script&lang=js&"
export * from "./QuemSomos.vue?vue&type=script&lang=js&"
import style0 from "./QuemSomos.vue?vue&type=style&index=0&id=d7ff6b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ff6b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
